// Sesi aktif (in-memory). Modul membaca peran/cabang dari sini.
import type { Session, Employee } from './types';

let _session: Session | null = null;

export const setSession = (s: Session | null): void => { _session = s; };
export const getSession = (): Session | null => _session;
export const currentUser = (): Employee | null => _session?.user ?? null;

/** Cabang aktif pengguna (null utk Owner/Manager lintas cabang). */
export const currentOutlet = (): string | null => _session?.user.outlet ?? null;
